import React from "react";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { GlobalReferenceModel } from "../Models/GlobalReferenceModel";

const GlobalReference: React.FC<{ blok: GlobalReferenceModel }> = ({
  blok,
}) => {
  return (
    <div
      className="global-reference"
      {...storyblokEditable(blok)}
      key={`global-ref-${blok._uid}`}
    >
      {blok && blok.reference && blok.reference.length > 0
        ? blok.reference.map(
            (reference) =>
              reference.content && (
                <StoryblokComponent
                  blok={reference.content}
                  key={reference.content._uid}
                />
              )
          )
        : null}
    </div>
  );
};

export default GlobalReference;
